/* tslint:disable */
/* eslint-disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';
import { RequestBuilder } from '../request-builder';
import { Observable } from 'rxjs';
import { map, filter } from 'rxjs/operators';

import { Count } from '../models/count';
import { Flight } from '../models/flight';
import { FlightPartial } from '../models/flight-partial';
import { FlightWithRelations } from '../models/flight-with-relations';
import { Hotel } from '../models/hotel';
import { NewTour } from '../models/new-tour';
import { Participant } from '../models/participant';
import { ParticipantPartial } from '../models/participant-partial';
import { ParticipantWithRelations } from '../models/participant-with-relations';
import { Tour } from '../models/tour';
import { TourPartial } from '../models/tour-partial';
import { TourWithRelations } from '../models/tour-with-relations';

@Injectable({
  providedIn: 'root',
})
export class TourControllerService extends BaseService {
  constructor(
    config: ApiConfiguration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * Path part for operation tourControllerProxyCreateAll
   */
  static readonly TourControllerProxyCreateAllPath = '/proxy/tours/bulk';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyCreateAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyCreateAll$Response(params?: {
    body?: Array<NewTour>
  }): Observable<StrictHttpResponse<Array<Tour>>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyCreateAllPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Tour>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyCreateAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyCreateAll(params?: {
    body?: Array<NewTour>
  }): Observable<Array<Tour>> {

    return this.proxyCreateAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Tour>>) => r.body as Array<Tour>)
    );
  }

  /**
   * Path part for operation tourControllerProxyCount
   */
  static readonly TourControllerProxyCountPath = '/proxy/tours/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyCount()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyCount$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyCount$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyCount(params?: {
    where?: any;
  }): Observable<Count> {

    return this.proxyCount$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerProxyFindFlights
   */
  static readonly TourControllerProxyFindFlightsPath = '/proxy/tours/{id}/flight';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyFindFlights()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyFindFlights$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<FlightWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyFindFlightsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FlightWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyFindFlights$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyFindFlights(params: {
    id: string;
    filter?: any;
  }): Observable<Array<FlightWithRelations>> {

    return this.proxyFindFlights$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FlightWithRelations>>) => r.body as Array<FlightWithRelations>)
    );
  }

  /**
   * Path part for operation tourControllerProxyCreateFlight
   */
  static readonly TourControllerProxyCreateFlightPath = '/proxy/tours/{id}/flight';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyCreateFlight()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyCreateFlight$Response(params: {
    id: string;
    body?: Flight
  }): Observable<StrictHttpResponse<Flight>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyCreateFlightPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Flight>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyCreateFlight$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyCreateFlight(params: {
    id: string;
    body?: Flight
  }): Observable<Flight> {

    return this.proxyCreateFlight$Response(params).pipe(
      map((r: StrictHttpResponse<Flight>) => r.body as Flight)
    );
  }

  /**
   * Path part for operation tourControllerProxyDeleteFlight
   */
  static readonly TourControllerProxyDeleteFlightPath = '/proxy/tours/{id}/flight';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyDeleteFlight()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyDeleteFlight$Response(params: {
    id: string;
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyDeleteFlightPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyDeleteFlight$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyDeleteFlight(params: {
    id: string;
    where?: any;
  }): Observable<Count> {

    return this.proxyDeleteFlight$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerProxyPatchFlight
   */
  static readonly TourControllerProxyPatchFlightPath = '/proxy/tours/{id}/flight';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyPatchFlight()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyPatchFlight$Response(params: {
    id: string;
    where?: any;
    body?: FlightPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyPatchFlightPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyPatchFlight$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyPatchFlight(params: {
    id: string;
    where?: any;
    body?: FlightPartial
  }): Observable<Count> {

    return this.proxyPatchFlight$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerProxyFindHotel
   */
  static readonly TourControllerProxyFindHotelPath = '/proxy/tours/{id}/hotel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyFindHotel()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyFindHotel$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<Hotel>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyFindHotelPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Hotel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyFindHotel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyFindHotel(params: {
    id: string;
  }): Observable<Hotel> {

    return this.proxyFindHotel$Response(params).pipe(
      map((r: StrictHttpResponse<Hotel>) => r.body as Hotel)
    );
  }

  /**
   * Path part for operation tourControllerProxyFindParticipants
   */
  static readonly TourControllerProxyFindParticipantsPath = '/proxy/tours/{id}/participant';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyFindParticipants()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyFindParticipants$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ParticipantWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyFindParticipantsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ParticipantWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyFindParticipants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyFindParticipants(params: {
    id: string;
    filter?: any;
  }): Observable<Array<ParticipantWithRelations>> {

    return this.proxyFindParticipants$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ParticipantWithRelations>>) => r.body as Array<ParticipantWithRelations>)
    );
  }

  /**
   * Path part for operation tourControllerProxyCreateParticipant
   */
  static readonly TourControllerProxyCreateParticipantPath = '/proxy/tours/{id}/participant';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyCreateParticipant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyCreateParticipant$Response(params: {
    id: string;
    body?: Participant
  }): Observable<StrictHttpResponse<Participant>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyCreateParticipantPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Participant>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyCreateParticipant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyCreateParticipant(params: {
    id: string;
    body?: Participant
  }): Observable<Participant> {

    return this.proxyCreateParticipant$Response(params).pipe(
      map((r: StrictHttpResponse<Participant>) => r.body as Participant)
    );
  }

  /**
   * Path part for operation tourControllerProxyDeleteParticipant
   */
  static readonly TourControllerProxyDeleteParticipantPath = '/proxy/tours/{id}/participant';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyDeleteParticipant()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyDeleteParticipant$Response(params: {
    id: string;
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyDeleteParticipantPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyDeleteParticipant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyDeleteParticipant(params: {
    id: string;
    where?: any;
  }): Observable<Count> {

    return this.proxyDeleteParticipant$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerProxyPatchParticipant
   */
  static readonly TourControllerProxyPatchParticipantPath = '/proxy/tours/{id}/participant';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyPatchParticipant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyPatchParticipant$Response(params: {
    id: string;
    where?: any;
    body?: ParticipantPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyPatchParticipantPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyPatchParticipant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyPatchParticipant(params: {
    id: string;
    where?: any;
    body?: ParticipantPartial
  }): Observable<Count> {

    return this.proxyPatchParticipant$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerProxyFindById
   */
  static readonly TourControllerProxyFindByIdPath = '/proxy/tours/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyFindById()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyFindById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<TourWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TourWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyFindById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyFindById(params: {
    id: string;
    filter?: any;
  }): Observable<TourWithRelations> {

    return this.proxyFindById$Response(params).pipe(
      map((r: StrictHttpResponse<TourWithRelations>) => r.body as TourWithRelations)
    );
  }

  /**
   * Path part for operation tourControllerProxyReplaceById
   */
  static readonly TourControllerProxyReplaceByIdPath = '/proxy/tours/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyReplaceById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyReplaceById$Response(params: {
    id: string;
    body?: Tour
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyReplaceByIdPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyReplaceById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyReplaceById(params: {
    id: string;
    body?: Tour
  }): Observable<void> {

    return this.proxyReplaceById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation tourControllerProxyDeleteById
   */
  static readonly TourControllerProxyDeleteByIdPath = '/proxy/tours/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyDeleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyDeleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyDeleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyDeleteById(params: {
    id: string;
  }): Observable<void> {

    return this.proxyDeleteById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation tourControllerProxyUpdateById
   */
  static readonly TourControllerProxyUpdateByIdPath = '/proxy/tours/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyUpdateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyUpdateById$Response(params: {
    id: string;
    body?: TourPartial
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyUpdateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyUpdateById(params: {
    id: string;
    body?: TourPartial
  }): Observable<void> {

    return this.proxyUpdateById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation tourControllerProxyFind
   */
  static readonly TourControllerProxyFindPath = '/proxy/tours';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyFind()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyFind$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<TourWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TourWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyFind$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  proxyFind(params?: {
    filter?: any;
  }): Observable<Array<TourWithRelations>> {

    return this.proxyFind$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TourWithRelations>>) => r.body as Array<TourWithRelations>)
    );
  }

  /**
   * Path part for operation tourControllerProxyCreate
   */
  static readonly TourControllerProxyCreatePath = '/proxy/tours';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyCreate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyCreate$Response(params?: {
    body?: NewTour
  }): Observable<StrictHttpResponse<Tour>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Tour>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyCreate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyCreate(params?: {
    body?: NewTour
  }): Observable<Tour> {

    return this.proxyCreate$Response(params).pipe(
      map((r: StrictHttpResponse<Tour>) => r.body as Tour)
    );
  }

  /**
   * Path part for operation tourControllerProxyUpdateAll
   */
  static readonly TourControllerProxyUpdateAllPath = '/proxy/tours';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `proxyUpdateAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyUpdateAll$Response(params?: {
    where?: any;
    body?: TourPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerProxyUpdateAllPath, 'patch');
    if (params) {
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `proxyUpdateAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  proxyUpdateAll(params?: {
    where?: any;
    body?: TourPartial
  }): Observable<Count> {

    return this.proxyUpdateAll$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerCreateAll
   */
  static readonly TourControllerCreateAllPath = '/tours/bulk';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAll$Response(params?: {
    body?: Array<NewTour>
  }): Observable<StrictHttpResponse<Array<Tour>>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerCreateAllPath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<Tour>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createAll(params?: {
    body?: Array<NewTour>
  }): Observable<Array<Tour>> {

    return this.createAll$Response(params).pipe(
      map((r: StrictHttpResponse<Array<Tour>>) => r.body as Array<Tour>)
    );
  }

  /**
   * Path part for operation tourControllerCount
   */
  static readonly TourControllerCountPath = '/tours/count';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `count()` instead.
   *
   * This method doesn't expect any request body.
   */
  count$Response(params?: {
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerCountPath, 'get');
    if (params) {
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `count$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  count(params?: {
    where?: any;
  }): Observable<Count> {

    return this.count$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerFindFlights
   */
  static readonly TourControllerFindFlightsPath = '/tours/{id}/flight';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findFlights()` instead.
   *
   * This method doesn't expect any request body.
   */
  findFlights$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<FlightWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerFindFlightsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<FlightWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findFlights$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findFlights(params: {
    id: string;
    filter?: any;
  }): Observable<Array<FlightWithRelations>> {

    return this.findFlights$Response(params).pipe(
      map((r: StrictHttpResponse<Array<FlightWithRelations>>) => r.body as Array<FlightWithRelations>)
    );
  }

  /**
   * Path part for operation tourControllerCreateFlight
   */
  static readonly TourControllerCreateFlightPath = '/tours/{id}/flight';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createFlight()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFlight$Response(params: {
    id: string;
    body?: Flight
  }): Observable<StrictHttpResponse<Flight>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerCreateFlightPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Flight>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createFlight$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createFlight(params: {
    id: string;
    body?: Flight
  }): Observable<Flight> {

    return this.createFlight$Response(params).pipe(
      map((r: StrictHttpResponse<Flight>) => r.body as Flight)
    );
  }

  /**
   * Path part for operation tourControllerDeleteFlight
   */
  static readonly TourControllerDeleteFlightPath = '/tours/{id}/flight';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteFlight()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFlight$Response(params: {
    id: string;
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerDeleteFlightPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteFlight$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteFlight(params: {
    id: string;
    where?: any;
  }): Observable<Count> {

    return this.deleteFlight$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerPatchFlight
   */
  static readonly TourControllerPatchFlightPath = '/tours/{id}/flight';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchFlight()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchFlight$Response(params: {
    id: string;
    where?: any;
    body?: FlightPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerPatchFlightPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `patchFlight$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchFlight(params: {
    id: string;
    where?: any;
    body?: FlightPartial
  }): Observable<Count> {

    return this.patchFlight$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerFindHotel
   */
  static readonly TourControllerFindHotelPath = '/tours/{id}/hotel';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findHotel()` instead.
   *
   * This method doesn't expect any request body.
   */
  findHotel$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<Hotel>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerFindHotelPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Hotel>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findHotel$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findHotel(params: {
    id: string;
  }): Observable<Hotel> {

    return this.findHotel$Response(params).pipe(
      map((r: StrictHttpResponse<Hotel>) => r.body as Hotel)
    );
  }

  /**
   * Path part for operation tourControllerFindParticipants
   */
  static readonly TourControllerFindParticipantsPath = '/tours/{id}/participant';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findParticipants()` instead.
   *
   * This method doesn't expect any request body.
   */
  findParticipants$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<Array<ParticipantWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerFindParticipantsPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<ParticipantWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findParticipants$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findParticipants(params: {
    id: string;
    filter?: any;
  }): Observable<Array<ParticipantWithRelations>> {

    return this.findParticipants$Response(params).pipe(
      map((r: StrictHttpResponse<Array<ParticipantWithRelations>>) => r.body as Array<ParticipantWithRelations>)
    );
  }

  /**
   * Path part for operation tourControllerCreateParticipant
   */
  static readonly TourControllerCreateParticipantPath = '/tours/{id}/participant';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `createParticipant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createParticipant$Response(params: {
    id: string;
    body?: Participant
  }): Observable<StrictHttpResponse<Participant>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerCreateParticipantPath, 'post');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Participant>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `createParticipant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  createParticipant(params: {
    id: string;
    body?: Participant
  }): Observable<Participant> {

    return this.createParticipant$Response(params).pipe(
      map((r: StrictHttpResponse<Participant>) => r.body as Participant)
    );
  }

  /**
   * Path part for operation tourControllerDeleteParticipant
   */
  static readonly TourControllerDeleteParticipantPath = '/tours/{id}/participant';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteParticipant()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteParticipant$Response(params: {
    id: string;
    where?: any;
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerDeleteParticipantPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteParticipant$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteParticipant(params: {
    id: string;
    where?: any;
  }): Observable<Count> {

    return this.deleteParticipant$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerPatchParticipant
   */
  static readonly TourControllerPatchParticipantPath = '/tours/{id}/participant';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `patchParticipant()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchParticipant$Response(params: {
    id: string;
    where?: any;
    body?: ParticipantPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerPatchParticipantPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `patchParticipant$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  patchParticipant(params: {
    id: string;
    where?: any;
    body?: ParticipantPartial
  }): Observable<Count> {

    return this.patchParticipant$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

  /**
   * Path part for operation tourControllerFindById
   */
  static readonly TourControllerFindByIdPath = '/tours/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `findById()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById$Response(params: {
    id: string;
    filter?: any;
  }): Observable<StrictHttpResponse<TourWithRelations>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerFindByIdPath, 'get');
    if (params) {
      rb.path('id', params.id, {});
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<TourWithRelations>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `findById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  findById(params: {
    id: string;
    filter?: any;
  }): Observable<TourWithRelations> {

    return this.findById$Response(params).pipe(
      map((r: StrictHttpResponse<TourWithRelations>) => r.body as TourWithRelations)
    );
  }

  /**
   * Path part for operation tourControllerReplaceById
   */
  static readonly TourControllerReplaceByIdPath = '/tours/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `replaceById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById$Response(params: {
    id: string;
    body?: Tour
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerReplaceByIdPath, 'put');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `replaceById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  replaceById(params: {
    id: string;
    body?: Tour
  }): Observable<void> {

    return this.replaceById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation tourControllerDeleteById
   */
  static readonly TourControllerDeleteByIdPath = '/tours/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `deleteById()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById$Response(params: {
    id: string;
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerDeleteByIdPath, 'delete');
    if (params) {
      rb.path('id', params.id, {});
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `deleteById$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  deleteById(params: {
    id: string;
  }): Observable<void> {

    return this.deleteById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation tourControllerUpdateById
   */
  static readonly TourControllerUpdateByIdPath = '/tours/{id}';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateById()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById$Response(params: {
    id: string;
    body?: TourPartial
  }): Observable<StrictHttpResponse<void>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerUpdateByIdPath, 'patch');
    if (params) {
      rb.path('id', params.id, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'text',
      accept: '*/*'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateById$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateById(params: {
    id: string;
    body?: TourPartial
  }): Observable<void> {

    return this.updateById$Response(params).pipe(
      map((r: StrictHttpResponse<void>) => r.body as void)
    );
  }

  /**
   * Path part for operation tourControllerFind
   */
  static readonly TourControllerFindPath = '/tours';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `find()` instead.
   *
   * This method doesn't expect any request body.
   */
  find$Response(params?: {
    filter?: any;
  }): Observable<StrictHttpResponse<Array<TourWithRelations>>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerFindPath, 'get');
    if (params) {
      rb.query('filter', params.filter, {});
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Array<TourWithRelations>>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `find$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  find(params?: {
    filter?: any;
  }): Observable<Array<TourWithRelations>> {

    return this.find$Response(params).pipe(
      map((r: StrictHttpResponse<Array<TourWithRelations>>) => r.body as Array<TourWithRelations>)
    );
  }

  /**
   * Path part for operation tourControllerCreate
   */
  static readonly TourControllerCreatePath = '/tours';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `create()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create$Response(params?: {
    body?: NewTour
  }): Observable<StrictHttpResponse<Tour>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerCreatePath, 'post');
    if (params) {
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Tour>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `create$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  create(params?: {
    body?: NewTour
  }): Observable<Tour> {

    return this.create$Response(params).pipe(
      map((r: StrictHttpResponse<Tour>) => r.body as Tour)
    );
  }

  /**
   * Path part for operation tourControllerUpdateAll
   */
  static readonly TourControllerUpdateAllPath = '/tours';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateAll()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAll$Response(params?: {
    where?: any;
    body?: TourPartial
  }): Observable<StrictHttpResponse<Count>> {

    const rb = new RequestBuilder(this.rootUrl, TourControllerService.TourControllerUpdateAllPath, 'patch');
    if (params) {
      rb.query('where', params.where, {});
      rb.body(params.body, 'application/json');
    }

    return this.http.request(rb.build({
      responseType: 'json',
      accept: 'application/json'
    })).pipe(
      filter((r: any) => r instanceof HttpResponse),
      map((r: HttpResponse<any>) => {
        return r as StrictHttpResponse<Count>;
      })
    );
  }

  /**
   * This method provides access to only to the response body.
   * To access the full response (for headers, for example), `updateAll$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateAll(params?: {
    where?: any;
    body?: TourPartial
  }): Observable<Count> {

    return this.updateAll$Response(params).pipe(
      map((r: StrictHttpResponse<Count>) => r.body as Count)
    );
  }

}
